/**
 * Newsletter Popup Controller
 * Gère l'affichage unique de la popup newsletter
 */
class NewsletterPopupController {
  constructor() {
    this.popup = document.getElementById('NewsletterPopup');
    this.closeButton = null;
    this.hasShown = false;
    this.delay = 10000; // 10 secondes
    this.storageKey = 'newsletter_popup_shown';
    
    this.init();
  }
  
  init() {
    if (!this.popup) return;
    
    // Vérifier si la popup a déjà été affichée
    if (this.hasPopupBeenShown()) {
      return;
    }
    
    // Attendre le délai avant d'afficher
    setTimeout(() => {
      this.showPopup();
    }, this.delay);
    
    this.setupEventListeners();
  }
  
  hasPopupBeenShown() {
    return localStorage.getItem(this.storageKey) === 'true';
  }
  
  showPopup() {
    if (this.hasShown || this.hasPopupBeenShown()) return;

    // L'image de fond n'est appliquée qu'à l'affichage réel, pour éviter
    // de la télécharger au chargement de la page (elle n'est visible qu'après ce délai).
    const content = this.popup.querySelector('.newsletter-popup-modal__content');
    if (content && content.dataset.bgImage) {
      content.style.backgroundImage = `url('${content.dataset.bgImage}')`;
    }

    this.popup.setAttribute('open', '');
    this.hasShown = true;
    
    // Marquer comme affichée dans le localStorage
    localStorage.setItem(this.storageKey, 'true');
    
    // Focus sur le premier input
    const emailInput = this.popup.querySelector('input[type="email"]');
    if (emailInput) {
      setTimeout(() => emailInput.focus(), 100);
    }
  }
  
  hidePopup() {
    this.popup.removeAttribute('open');
  }
  
  setupEventListeners() {
    // Bouton de fermeture
    this.closeButton = this.popup.querySelector('.newsletter-popup__close');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.hidePopup();
      });
    }
    
    // Fermeture avec Escape
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.popup.hasAttribute('open')) {
        this.hidePopup();
      }
    });
    
    // Fermeture en cliquant à l'extérieur
    this.popup.addEventListener('click', (event) => {
      if (event.target === this.popup) {
        this.hidePopup();
      }
    });
    
    // Gestion du succès du formulaire
    const form = this.popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', (event) => {
        // Attendre un peu pour voir si le formulaire a réussi
        setTimeout(() => {
          const successMessage = this.popup.querySelector('.newsletter-form__message--success');
          if (successMessage) {
            // Fermer la popup après succès
            setTimeout(() => {
              this.hidePopup();
            }, 2000);
          }
        }, 500);
      });
    }
  }
}

// Initialiser quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  new NewsletterPopupController();
});
